<template>
  <component :is="currentView"></component>
</template>

<script>
import {
  CheckoutStepOne,
  CheckoutStepTwo,
  CheckoutStepThree,
  CheckoutStepFour,
  CheckoutStepFive,
} from '@/views'

export default {
  name: 'Campground',
  components: {
    CheckoutStepOne,
    CheckoutStepTwo,
    CheckoutStepThree,
    CheckoutStepFour,
  },
  props: ['step'],
  computed: {
    currentView() {
      const stepComponentMapping = {
        '1': CheckoutStepOne,
        '2': CheckoutStepTwo,
        '3': CheckoutStepThree,
        '4': CheckoutStepFour,
        '5': CheckoutStepFive,
      }
      return stepComponentMapping[this.step]
    },
  },
}
</script>
